(function() {
  /* Hamburger menu toggle (homepage) */
  var menuToggle = document.getElementById('home-menu-toggle');
  var menuDrawer = document.getElementById('home-menu-drawer');
  var menuClose = document.getElementById('home-menu-close');

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', function() {
      var isOpen = menuDrawer.classList.toggle('is-open');
      menuToggle.classList.toggle('is-open', isOpen);
    });

    if (menuClose) {
      menuClose.addEventListener('click', function() {
        menuDrawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
      });
    }

    document.addEventListener('click', function(e) {
      if (menuDrawer.classList.contains('is-open') &&
          !menuDrawer.contains(e.target) &&
          !menuToggle.contains(e.target)) {
        menuDrawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
      }
    });
  }

  /* Product page: thumbnail switching */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-product-thumb]');
    if (thumb) {
      e.preventDefault();
      var src = thumb.getAttribute('data-product-thumb');
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = src;
      }
      var allThumbs = thumb.parentElement.querySelectorAll('[data-product-thumb]');
      allThumbs.forEach(function(t) {
        t.classList.remove('product-gallery__thumb--active');
      });
      thumb.classList.add('product-gallery__thumb--active');
    }
  });

  /* Cart: quantity update */
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  /* Cart: remove item */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (btn) {
      var key = btn.getAttribute('data-cart-remove');
      var input = document.querySelector('input[name="updates[' + key + ']"]');
      if (input) {
        input.value = '0';
        input.closest('form').submit();
      }
    }
  });
})();
